import { AssetFile, SingleAssetUsage } from '@/store/modules/asset'
import { AssetsModule } from '@/store/modules/asset'
import { AppModule } from '@/store/modules/app'
import { ToolbarModule } from '@/store/modules/toolbar'

export class AssetUsage {

    public static prepareUsage(asset: AssetFile) {
        let usageKind = AssetUsage.getUsageKind()
        if (usageKind && !asset.pendingUsage[usageKind]) {
            if (asset.usage[usageKind]) {
                let existingUsage = asset.usage[usageKind] as SingleAssetUsage
                let usage: SingleAssetUsage = {
                    rotation: existingUsage.rotation,
                    zoom: existingUsage.zoom,
                    center: [existingUsage.center[0], existingUsage.center[1]]
                }
                AssetsModule.SetPendingUsage([asset, usageKind, usage])
            } else {
                let usage: SingleAssetUsage = {
                    rotation: 0,
                    zoom: 0,
                    center: [asset.rect[0] / 2.0, asset.rect[1] / 2.0]
                }
                AssetsModule.SetPendingUsage([asset, usageKind, usage])
            }
        }
    }

    public static captureUsage(asset: AssetFile) {
        let usageKind = AssetUsage.getUsageKind()
        if (usageKind && asset.pendingUsage[usageKind]) {
            let center = [...ToolbarModule.center]
            let usage: SingleAssetUsage = {
                rotation: ToolbarModule.rotation,
                zoom: ToolbarModule.zoom,
                center: center as [number, number]
            }
            AssetsModule.SetPendingUsage([asset, usageKind, usage])
        }
    }

    public static commitUsage(asset: AssetFile, singleUsage: boolean): SingleAssetUsage | undefined {
        let usageKind = AssetUsage.getUsageKind()
        if (usageKind && asset.pendingUsage[usageKind]) {
            if (singleUsage) {
                for (let currentAsset of AssetsModule.assets) {
                    if (currentAsset !== asset && currentAsset.usage[usageKind]) {
                        AssetsModule.SetPendingUsage([currentAsset, usageKind, currentAsset.usage[usageKind]])
                        AssetsModule.SetUsage([currentAsset, usageKind])
                    }
                }
            }
            let center = [...ToolbarModule.center]
            let usage: SingleAssetUsage = {
                rotation: ToolbarModule.rotation,
                zoom: ToolbarModule.zoom,
                center: center as [number, number]
            }
            AssetsModule.SetPendingUsage([asset, usageKind])
            AssetsModule.SetUsage([asset, usageKind, usage])
            return usage
        }
    }

    public static hasUsage(asset: AssetFile): boolean {
        let usageKind = AssetUsage.getUsageKind()
        let hasUsage = false
        for (let currentUsageKind in asset.usage) {
            if (usageKind !== currentUsageKind) {
                hasUsage = true
                break
            } else {
                if (asset.selected) {
                    hasUsage = true
                    break
                }
            }
        }
        if (!hasUsage) {
            hasUsage = asset.selected
        }
        return hasUsage
    }

    public static getCommitedAsset(): AssetFile | undefined {
        let usageKind = AssetUsage.getUsageKind()
        let asset: AssetFile | undefined
        if (usageKind) {
            for (let currentAsset of AssetsModule.assets) {
                if (currentAsset.usage[usageKind]) {
                    asset = currentAsset
                    break
                }
            }
        }
        return asset
    }

    private static getUsageKind() {
        return AppModule.steps[AppModule.currentStepIndex].usageName
    }

    public static deleteAllUsage() {
        let usageKind = AssetUsage.getUsageKind()
        if (usageKind) {
            for (let currentAsset of AssetsModule.assets) {
                if (currentAsset.usage[usageKind]) {
                    AssetsModule.SetPendingUsage([currentAsset, usageKind, currentAsset.usage[usageKind]])
                    AssetsModule.SetUsage([currentAsset, usageKind])
                }
            }
        }
    }
}